import React from 'react'

import './buttonTimer.scss'

const ButtonTimer = ({enable, time, title, value = '', onClick, style = {}, className = '', variant = ''}) => {

    const confirm = () => {
        if (enable) onClick(value)
    }

    return <div
        id={`button-${variant}`}
        className={className}
        style={enable ? {} : {backgroundColor: 'gray', color: 'white'}}
        onClick={confirm}>
        {(!!time) && <label className={'time'} style={enable ? {} : {backgroundColor: 'white', color: 'gray'}}>
            {time}
        </label>
        }
        {title}
    </div>
}

export default ButtonTimer
